import { Filter } from '@ais-ui/websockets';
import { useFilterContext } from '../Map/FilterContext';
import React, { useCallback, useEffect, useState } from 'react';
import { isFilterApplied } from './utils';
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiFunnel, PiFunnelFill } from 'react-icons/pi';

interface ApplyFilterButtonProps {
  filter: Filter;
}

export const ApplyFilterButton = ({ filter }: ApplyFilterButtonProps) => {
  const filterContext = useFilterContext();
  const [isApplied, setIsApplied] = useState<boolean>(
    isFilterApplied(filter, filterContext.customFilters)
  );

  useEffect(() => {
    setIsApplied(isFilterApplied(filter, filterContext.customFilters));
  }, [filter, filterContext.customFilters]);

  const onApply = useCallback(() => {
    let newFilters: Filter[];
    if (!isApplied) {
      newFilters = [...filterContext.customFilters, filter];
    } else {
      newFilters = filterContext.customFilters.filter(
        (f) => f.uuid !== filter.uuid
      );
    }
    // Update filters - AISMapLayer effect handles apply and refresh
    filterContext.setCustomFilters(newFilters);
  }, [isApplied, filterContext, filter]);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button size="smIcon" variant="ghost" onClick={onApply}>
          {isApplied ? (
            <PiFunnelFill className="size-4 text-primary" />
          ) : (
            <PiFunnel className="size-4"></PiFunnel>
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {isApplied ? 'Remove filter' : 'Apply filter'}
      </TooltipContent>
    </Tooltip>
  );
};
